<div *ngIf="appService.messages.length || !appService.acceptCookies || appService.showMap" class="messages-container">
	<div class="content">
		<p><button class="close" (click)="appService.clear()">X</button></p>
		<p i18n="cookieText" *ngIf="!appService.acceptCookies">Esta página contiene cookies para la mejora de la interactividad con el usuario. Contacto con <a href="https://www.audio-lab.org">nosotros</a> para cualquier duda. <strong>Buena escucha</strong></p>
		<p i18n="welcomeMap" *ngIf="appService.showMap">Bienvenido al mapa de sonidos de Sartaguda</p>
		<p *ngFor="let m of appService.messages" [innerHTML]="m"></p>
		<button *ngIf="appService.button" class="clear" (click)="appService.clear()" title="Confirmación" i18n="Boton aceptar">Entendido</button>
	</div>
</div>



// WEBPACK FOOTER //
// ./src/app/messages/messages.component.html